import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { Button, Col, Input, Label, Row, Table } from "reactstrap";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";

const LIMITE = 50;
const headers = () => ({ Authorization: `Bearer: ${localStorage.getItem("app_token")}` });

function ListadoLogs() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [users, setUsers] = useState([]);
  const [usuario, setUsuario] = useState("");
  const [inicio, setInicio] = useState(moment().subtract(1, "months").format("YYYY-MM-DD"));
  const [fin, setFin] = useState(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    axios.get(URL_USERS, { headers: headers() }).then((r) => setUsers(r.data)).catch(console.log);
  }, [URL_USERS]);

  useEffect(() => {
    const params = new URLSearchParams({ pagina, limite: LIMITE, inicio, fin });
    if (usuario) params.set("usuario", usuario);
    axios.get(`${URL_LOGS}?${params.toString()}`, { headers: headers() })
      .then((r) => { setLogs(r.data.datos); setTotal(r.data.total); })
      .catch(console.log);
  }, [URL_LOGS, pagina, usuario, inicio, fin]);

  const paginas = Math.max(Math.ceil(total / LIMITE), 1);
  const filtro = (setter) => (e) => { setter(e.target.value); setPagina(1); };

  if (!user.menu_logs) return <Header />;

  return (
    <>
      <Header />
      <div className="card container col-12">
        <div className="page-header">
          <div><h3 className="page-title">Bitacora</h3><p className="page-subtitle">{total} movimientos</p></div>
        </div>
        <Row className="filter-row">
          <Col md={2}><Label>Desde</Label><Input type="date" value={inicio} onChange={filtro(setInicio)} /></Col>
          <Col md={2}><Label>Hasta</Label><Input type="date" value={fin} onChange={filtro(setFin)} /></Col>
          <Col md={4}>
            <Label>Usuario</Label>
            <Input type="select" value={usuario} onChange={filtro(setUsuario)}>
              <option value="">Todos</option>
              {users.map((a) => <option key={a._id} value={a._id}>{a.nombre} {a.apellido}</option>)}
            </Input>
          </Col>
        </Row>
        <Table size="sm" responsive className="mt-3">
          <thead><tr><th>Fecha</th><th>Tipo</th><th>Detalle</th><th>Usuario</th></tr></thead>
          <tbody>
            {logs.map((a) => (
              <tr key={a._id}>
                <td>{moment(a.createdAt).format("YYYY-MM-DD HH:mm")}</td>
                <td>{a.tipo}</td><td>{a.detalle}</td>
                <td>{a.user?.[0]?.nombre} {a.user?.[0]?.apellido}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="text-center">Sin movimientos en el periodo</td></tr>}
          </tbody>
        </Table>
        <div className="form-acciones">
          <Button size="sm" color="secondary" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>Anterior</Button>
          <span style={{ alignSelf: "center", fontSize: ".75rem" }}>Pagina {pagina} de {paginas}</span>
          <Button size="sm" color="secondary" disabled={pagina >= paginas} onClick={() => setPagina(pagina + 1)}>Siguiente</Button>
        </div>
      </div>
    </>
  );
}

export default ListadoLogs;
